import { FlowStepData } from "../FlowStepData";
import { MultiExecutableOutputDefinition } from "../../../Common/Execution/MultiExecutable";

export class MultiOutputTestStep extends FlowStepData {
    readonly __type: string = "multi_output_test";

    paths: string[] = ["yes", "no", "no data"];

    firstPathMustContinue: boolean = true;

    constructor() {
        super();
        this.name = "Multi Output Test Step";
    }

    getStorageData(): object {
        let data = super.getStorageData();

        Reflect.set(data, "firstPathMustContinue", this.firstPathMustContinue);
        return data;
    }

    setStorageData(data: object) {
        super.setStorageData(data);

        this.firstPathMustContinue = Reflect.get(data, "firstPathMustContinue");
    }

    getOutcomes(): MultiExecutableOutputDefinition[] {
        return this.paths.map((value) => {
            return new MultiExecutableOutputDefinition(value);
        });
    }
}
